export type TrunkStatusTone = 'success' | 'busy' | 'warning' | 'destructive' | 'default';

export type TrunkStatusMeta = {
  label: string;
  tone: TrunkStatusTone;
};

const TRUNK_STATUS_MAP: Record<number, TrunkStatusMeta> = {
  0: { label: 'Unknown', tone: 'default' },
  1: { label: 'Idle', tone: 'success' },
  2: { label: 'Busy', tone: 'busy' },
  3: { label: 'Idle (unmonitored)', tone: 'success' },
  4: { label: 'Registering', tone: 'busy' },
  41: { label: 'Registration failed', tone: 'destructive' },
  42: { label: 'Unreachable', tone: 'destructive' },
  43: { label: 'Unavailable', tone: 'destructive' },
  44: { label: 'Disabled', tone: 'warning' },
  45: { label: 'Authentication failed', tone: 'destructive' },
};

export function getTrunkStatusMeta(status?: number): TrunkStatusMeta {
  if (status === undefined || Number.isNaN(status)) {
    return TRUNK_STATUS_MAP[0];
  }
  return TRUNK_STATUS_MAP[status] ?? TRUNK_STATUS_MAP[0];
}

export function isTrunkEnabled(status?: number): boolean {
  return status !== 44;
}

export function trunkToneToBadgeVariant(
  tone: TrunkStatusTone
): 'success' | 'info' | 'warning' | 'danger' | 'default' {
  switch (tone) {
    case 'success':
      return 'success';
    case 'busy':
      return 'info';
    case 'warning':
      return 'warning';
    case 'destructive':
      return 'danger';
    default:
      return 'default';
  }
}